import { SearchIcon } from '@primer/octicons-react';
import { Box, Octicon } from '@primer/react';
import { useContext } from 'react';
import TextInput from '../text-input';
import { DataTableContainerContext, IDataTableContext } from './DataTable';
import styles from "./DataTable.module.css";
import clsx from 'clsx';
const Header = () => {
    const { props, headerGroups, allColumns, setConditions, conditions } = useContext<IDataTableContext>(DataTableContainerContext);

    const onFilterChange = (field: any, operator?: any, value?: any) => {
        if (!value) {
            removeCondition(field);
            return;
        }
        const cond = conditions.find(x => x.field === field);
        if (cond) {
            updateCondition(field, operator, value)
        } else {
            addCondition(field, operator, value)
        }
    }
    // Thêm điều kiện mới
    const addCondition = (field: any, operator?: any, value?: any) => {
        setConditions([...conditions.filter(x => x.field && x.field !== field), { field: field, operator: operator ?? "equals", value: value ?? "" }]);
    };

    // Xóa điều kiện
    const removeCondition = (field: any) => {
        const newConditions = conditions.filter(x => x.field !== field);
        setConditions(newConditions);

    };
    // Cập nhật điều kiện
    const updateCondition = (field: any, operator?: any, value?: any) => {
        setConditions(conditions.map(c => {
            if (c.field === field) {
                return {
                    ...c,
                    operator: operator ?? "equals",
                    value
                }
            }
            return c;
        }));
    };
    const getWidth = (column: any): any => {
        if (column.placeholderOf) {
            return getWidth(column.placeholderOf);
        }
        return column.width;
    }
    return (
        <thead className={styles.header}>
            {headerGroups.map((headerGroup: any, hIdx) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={hIdx}>
                    {headerGroup.headers.map((column: any, idx: number) => {

                        const width = getWidth(column);
                        return (
                            <th
                                {...column.getHeaderProps()}
                                style={{
                                    textAlign: column.align ?? "left",
                                    // width: column.placeholderOf
                                    //     ? column.placeholderOf.width
                                    //     : column.width,
                                    width: width,
                                    minWidth: column.placeholderOf
                                        ? column.placeholderOf.minWidth
                                        : column.minWidth,
                                    left: column.fixed ? (column.id === "selection" ? 0 : 40) : undefined,
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }}
                                key={idx}
                                className={clsx(column.fixed ? styles.fixed_column_header : '')}
                            >
                                {column.headerRender
                                    ? column.headerRender()
                                    : column.render("Header")}
                            </th>
                        );
                    })}
                </tr>
            ))}
            {(props.filterRow?.enable === true || !props.filterRow) &&
                <tr role="row">
                    {allColumns.map((colum: any) => {
                        return (
                            <th style={{
                                position: "unset",
                                left: colum.fixed ? (colum.id === "selection" ? 0 : 40) : undefined
                            }}
                                className={clsx(colum.fixed ? styles.fixed_column_header : '')}
                            >
                                {colum.dataField &&
                                    <Box sx={{ margin: "-0.5rem -0.75rem" }}>
                                        <TextInput
                                            // className="text-input-noborder"
                                            block
                                            leadingVisual={<Box sx={{ color: "#656d76" }}>
                                                <Octicon icon={SearchIcon} sx={{ width: "12px", height: "12px" }} />
                                            </Box>}
                                            sx={{
                                                backgroundColor: "#F5F8FA",
                                                // outline:"none!important",
                                                boxShadow: "none",
                                                border: "0!important",
                                                mt: "1px"
                                            }}
                                            onValueDelayChanged={(value) => {
                                                onFilterChange(colum.dataField, "contains", value)
                                            }} />
                                    </Box>
                                }
                            </th>
                        );
                    })}
                </tr>
            }
        </thead>
    );
};

export default Header;